export default "https://assets-v2.scaler.com/packs/files/apple-watch.6bd968.webp";